function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

/**
 * Gets a token for the given scope. If the token can be retrieved silently, if is. Otherwise
 * it will fall back to using a redirect to get the token.
 */
export function getTokenWithRedirectFallback(_x, _x2, _x3, _x4) {
  return _getTokenWithRedirectFallback.apply(this, arguments);
}

function _getTokenWithRedirectFallback() {
  _getTokenWithRedirectFallback = _asyncToGenerator(function* (instance, scope, authPaths, impersonate) {
    return new Promise((resolve, reject) => {
      instance.acquireTokenSilent({
        scopes: [scope],
        authority: authPaths.authority + '/' + (impersonate ? authPaths.impersonatePolicyPath : authPaths.signInPolicyPath)
      }).then(response => {
        if (response.accessToken) {
          resolve(response.accessToken);
        } else {
          console.error("Got empty access token for scope ".concat(scope), response);
          reject("Got empty access token for scope ".concat(scope));
        }
      }).catch(e => {
        if (e instanceof BrowserAuthError) {
          console.log({
            errorCode: e.errorCode,
            errorMessage: e.errorMessage,
            name: e.name
          });

          if (e.errorCode === 'no_account_error') {
            reject(e);
            return;
          }
        } else if (e instanceof InteractionRequiredAuthError) {
          console.debug("Error while getting token for ".concat(scope, " silently. Will retry with redirect."), e);
          instance.acquireTokenRedirect({
            scopes: [scope],
            authority: authPaths.authority + '/' + (impersonate ? authPaths.impersonatePolicyPath : authPaths.signInPolicyPath)
          }).catch(e => reject(e));
        } else {
          reject(e);
        }
      });
    });
  });
  return _getTokenWithRedirectFallback.apply(this, arguments);
}